import { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      title: formatMessage(messages.title),
      description: formatMessage(messages.description),
      firstCheckText: formatMessage(messages.firstCheckText),
      secondCheckText: formatMessage(messages.secondCheckText),
      btnCancel: formatMessage(messages.btnCancel),
      btnSubmit: formatMessage(messages.btnSubmit),
    };

    return { translations };
  }, [formatMessage]);
  return result;
};
export default useTranslations;
